import React from 'react';

import styles from './troy.module.scss';

import { getCustomers, getDecisions } from '../../actions';
import { connectTo } from '../../utils';

class QualtricsFeedback extends React.Component {
  componentDidMount() {
    const { getDecisions, getCustomers, isAuthenticated } = this.props;
    if (isAuthenticated) {
      getDecisions();
      getCustomers();
    }
  }

  render() {
    const { surveyUrl } = this.props;
    return (
      /* TODO: replace the link with the one wich is provided by the middleware */
      <div className={styles['qfeedback-widget__iframe-wrapper']}>
        {(
          <iframe
            className={styles['qfeedback-widget__iframe']}
            src={surveyUrl}
            title="qfeedback-iframe"
            frameBorder="0"
          />
        ) || null}
      </div>
    );
  }
}

export default connectTo(
  ({
    auth: { token },
    //    decisions: { 'troy.feature.qualtrics.survey': qualtricsDecision },
    liability: { surveyUrl }
  }) => ({
    token,
    surveyUrl
  }),
  { getDecisions, getCustomers },
  QualtricsFeedback
);
